export const BASE_ENDPOINT_PATH = "sales-api/advanced-search";
